import "babel-polyfill";

import ConfigurationForm from './ConfigurationForm/ConfigurationForm';
import Angletool from './Angletool/Angletool';
import Articletool from './Articletool/Articletool';

$(document).ready(function() {

	new ConfigurationForm();

	if(document.getElementById('angletool')) {
		new Angletool();
	}

	if(document.getElementById('articletool')) {
		new Articletool();
	}
});
